/*
 * @Author: 鸦雀銮翎
 * @Date: 2023-02-20 08:54:40
 * @LastEditTime: 2024-03-08 15:08:55
 * @Description:
 * @FilePath: \website\src\assets\js\request.js
 * 可以输入预定的版权声明、个性签名、空行等
 */

import axios from 'axios'
import { Notification, MessageBox, Message, Loading } from 'element-ui'
axios.defaults.headers['Content-Type'] = 'application/json;charset=utf-8'

// 创建axios实例
const service = axios.create({
  // axios中请求配置有baseURL选项，表示请求URL公共部分
  // baseURL: process.env.VUE_APP_BASE_API,
  baseURL: 'http://wwwadm.tudouec.com',
  // 超时
  timeout: 10000
})

// request拦截器
service.interceptors.request.use(config => {

  return config

}, error => {
  console.log(error)
  Promise.reject(error)
})

// 响应拦截器
service.interceptors.response.use(res => {
  // 未设置状态码则默认成功状态
  // const code = res.data.code || 200;
  // // 获取错误信息
  // const msg = errorCode[code] || res.data.msg || errorCode['default']
  // // 二进制数据则直接返回
  // if(res.request.responseType ===  'blob' || res.request.responseType ===  'arraybuffer'){
  //   return res.data
  // }
  // if (code === 500) {
  //   Message({
  //     message: msg,
  //     type: 'error'
  //   })
  //   return Promise.reject(new Error(msg))
  // } else if (code !== 200) {
  //   Notification.error({
  //     title: msg
  //   })
  //   return Promise.reject('error')
  // } else {
  //   return res.data
  // }
  return res.data
},
  error => {
    console.log('err' + error)
    let { message } = error;
    if (message == "Network Error") {
      message = "后端接口连接异常";
    }
    else if (message.includes("timeout")) {
      message = "系统接口请求超时";
    }
    else if (message.includes("Request failed with status code")) {
      message = "系统接口" + message.substr(message.length - 3) + "异常";
    }
    Message({
      message: message,
      type: 'error',
      duration: 5 * 1000
    })
    return Promise.reject(error)
  }
)

const market = axios.create({
  // axios中请求配置有baseURL选项，表示请求URL公共部分
  // baseURL: process.env.VUE_APP_BASE_API,
  baseURL: 'https://api.agri114.cn',
  // 超时
  timeout: 10000,
  headers: {
    "X-API-KEY": "781da19e1c50f47d3c7a2394ca4bf059-unpaid",
  },
})
// 响应拦截器
market.interceptors.response.use(res => {
  if(res.status != 200){}
  return res.data
},
  error => {
    console.log('err' + error)
    let { message } = error;
    if (message == "Network Error") {
      message = "后端接口连接异常";
    }
    else if (message.includes("timeout")) {
      message = "系统接口请求超时";
    }
    else if (message.includes("Request failed with status code")) {
      message = "系统接口" + message.substr(message.length - 3) + "异常";
    }
    Message({
      message: message,
      type: 'error',
      duration: 5 * 1000
    })
    return Promise.reject(error)
  }
)
export { service, market }



// WEBPACK FOOTER //
// ./src/assets/js/request.js